import { useState, useEffect,useRef } from "react";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { Avatar, TextField, Box, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import {
  deteleteImage,
  // fetchAllEntities,
  fetchEntityById,
  postdatas } from "../../apis/apiService";
import { toast } from "react-toastify";
import Loader from "../../components/common/Loader";
import { useFetchPersonalSettingsQuery, useFetchUserInfoQuery } from "../../slice/logdetailSlice";
import { IoMdDownload } from "react-icons/io";
import { Modal, Typography } from "@mui/material";
import { saveAs } from "file-saver";
import { ApplyLeaveRequest } from "../../apis/apiService";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PersonalSetting = () => {
  const [image, setImage] = useState(null);
  const [hover, setHover] = useState(false);
  const [recoverdata, setRecoverData] = useState([]);
  const { id: login_user_id } = useCurrentUser();
  const passwordRef = useRef(null);
  const [loading, setLoading] = useState(false);
 const navigate = useNavigate()
  const [userDetails, setUserDetails] = useState({
    firstname: "",
    lastname: "",
    phone_number: "",
    theme: "", // Default value
  });

  const [open, setOpen] = useState(false);
  const [toggleOpen, setToggleOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [show2FAModal, setShow2FAModal] = useState(false);
  const token = localStorage.getItem("access_token");


    useEffect(() => {
    if (toggleOpen && passwordRef.current) {
      passwordRef.current.focus();
    }
  }, [toggleOpen]);

  const handleOpen = async () => {

    setLoading(true);

    try {
      const response = await fetchEntityById("get2FARecoveryCodes", login_user_id);

      if (response?.status && response?.data) {
        setRecoverData(response.data);
        setOpen(true); // ✅ open modal only after success
      } else {
        toast.error(response?.message || "Failed to fetch recovery codes");
      }
    } 
    catch (err) {
      console.error("Error fetching recovery codes:", err);
      toast.error(
        err?.data?.message || "Something went wrong while fetching codes"
      );
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setRecoverData(null);
  };

  const handleCopyCodes = () => {
    if (!recoverdata?.two_fa_recovery_codes?.length) return;

    // Create a string of all codes separated by newline
    const codesString = recoverdata.two_fa_recovery_codes
      .map((item) => item.code)
      .join("\n");

    // Copy to clipboard
    navigator.clipboard
      .writeText(codesString)
      .then(() => {
        toast.success("Recovery codes copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy codes:", err);
        toast.error("Failed to copy codes");
      });
  };

  const generateTxt = (data) => {
    const today = new Date();
    const dateString = today.toLocaleDateString();

    let txtContent = `Name: ${data.name || ""}\n`;
    txtContent += `Download Date: ${dateString}\n\n`;
    txtContent += "#\tCode\t\tUsed\n";

    data.two_fa_recovery_codes.forEach((codeObj, idx) => {
      txtContent += `${idx + 1}\t${codeObj.code}\t${
        codeObj.used ? "Yes" : "No"
      }\n`;
    });

    const blob = new Blob([txtContent], { type: "text/plain;charset=utf-8" });
    saveAs(blob, `2FA_Recovery_Codes_${data.name || "User"}.txt`);
  };

  const {
    data: personal_details,
    refetch,
    isLoading,
  } = useFetchPersonalSettingsQuery();
  const { data, refetch: user_list_info_refetch } = useFetchUserInfoQuery();
  // //console.log()("API_Response:", personal_details);

  const {
    email = "",
    firstname = "",
    lastname = "",
    phone_number = "",
    theme = "",
    user_id = "",
    image_url = "",
    two_factor_verified = false,
  } = personal_details || {};

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (personal_details) {
      setIsActive(!!personal_details.two_factor_verified);
    }
  }, [personal_details]);

  //     const getQrLink = async () => {
  //       console.log("one code",isActive);

  //      try {
  //        const response = await fetchAllEntities("setup-2fa");
  //        //console.log("Activity response:", response.data);
  //         console.log("response",response);

  //      } catch (error) {
  //        console.error("Error fetching activity data:", error);
  //        setRecoverData([]);
  //      }
  //    };

  //   useEffect(() => {
  //   if (isActive === false) {
  //     getQrLink();
  //   }
  // }, [isActive]);

  const handleToggle = () => {
    setToggleOpen(true);
  };

  const handleToggleClose = () => {
    setToggleOpen(false);
    setPassword("");
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const payload = { password, user_id: login_user_id };
      const response = await ApplyLeaveRequest("reset-2fa", payload, token);

      if (response?.success) {
        setIsActive(false);
        toast.success("2FA Disabled Successfully");
        handleClose();
        setOpen(false);
        navigate("/twofactor-scan");
      } else {
        // handle API errors gracefully
        toast.error(response?.message || "Failed to disable 2FA");
      }
    } 
    catch (error) {
      console.error("API error:", error);

      // check if error is 401 and prevent redirect
      if (error.response?.status === 401) {
        toast.error("Incorrect password. Please try again.");
        return;
      }

      toast.error(error?.message || "Failed to verify password");
    } 
    finally {
      setLoading(false);
    }
  };

  // ✅ Set initial values when data is available

  // useEffect(() => {
  //   if (image_url) {
  //     setImage(image_url || null);
  //   }
  // }, [image_url]);

  // ✅ Handle input changes and update state

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    refetch();
  }, []);

  // ✅ Log data when the user clicks outside the input field
  const handleBlur = async (e) => {
    const { name, value } = e.target;

    // Create FormData object
    const formData = new FormData();
    formData.append("firstname", userDetails.firstname);
    formData.append("lastname", userDetails.lastname);
    formData.append("phone_number", userDetails.phone_number);
    formData.append("theme", userDetails.theme);

    // Append image if it exists
    // if (image && image instanceof File) {
    //   formData.append("image_url", image);
    // }
    // //console.log()("image_url in update response :", image);

    try {
      const response = await postdatas("settings/profile", "update", formData);
      // //console.log()("Update_Response:", response);

      if (response.status) {
        // //console.log()("Profile updated successfully");
        toast.success("Profile updated successfully");
        refetch();
        user_list_info_refetch();
      } else {
        console.error("Update failed:", response.message);
      }
    } 
    catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleThemeChange = (e) => {
    const selectedTheme = e.target.value;
    setUserDetails((prev) => ({ ...prev, theme: selectedTheme }));
  };

  // ✅ Handle Image Upload and Log Filename
  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setImage(URL.createObjectURL(file));

      const formData = new FormData();
      formData.append("image", file);
      try {
        const response = await postdatas("settings/profile","update-profile", formData);
        // //console.log()("Image Upload Response:", response);
        toast.success("Profile image updated successfully!");
        refetch();
        user_list_info_refetch();
      } 
      catch (error) {
        console.error("Error uploading image:", error);
        toast.error(error.message || "file must less than 2mb");
      }
    }
  };
  // //console.log()("image_name", image_url);

  const handleImageRemove = async () => {
    // setImage(null);
    try {
      const response = await deteleteImage("settings/profile/delete");
      // //console.log()("Image Removed", response);
      toast.success("Profile image removed successfully!");
      refetch();
      user_list_info_refetch();
    } catch (error) {
      console.error("Error removing image:", error);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (!personal_details) return; // ✅ Prevents unnecessary execution

    setUserDetails((prev) => {
      if (
        prev.firstname !== personal_details.firstname ||
        prev.lastname !== personal_details.lastname ||
        prev.phone_number !== personal_details.phone_number ||
        prev.theme !== personal_details.theme
      ) {
        return {
          firstname: personal_details.firstname || "",
          lastname: personal_details.lastname || "",
          phone_number: personal_details.phone_number || "",
          theme: personal_details.theme || "",
        };
      }
      return prev; // ✅ Prevents unnecessary re-renders
    });
  }, [personal_details]);
  useEffect(() => {
    if (personal_details?.image_url) {
      setImage(personal_details.image_url);
    }
  }, [personal_details]);
  // //console.log()("Fetched_Image URL:", personal_details?.image_url);

  // if (isLoading || !personal_details) {
  //   return <p>Loading...</p>;
  // }
  return (
    <form className="mt-3 mx-2">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="row p-3 bg-white rounded">
          <div className="col-md-3">
            <Box
              sx={{
                position: "relative",
                width: "250px",
                height: "250px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
                padding: "10px",
              }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              {image ? (
                <Avatar
                  src={image}
                  alt=""
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <Avatar sx={{ width: "100%", height: "100%" }} />
              )}
              {hover && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "30%",
                    display: "flex",
                    gap: "10px",
                    padding: "20px",
                  }}
                >
                  <div className="bg-white rounded">
                    <Button
                      // className=" text-theme"
                      size="medium"
                      component="label"
                      style={{ color: "var(--text-color)" }}
                    >
                      Upload
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleImageUpload}
                      />
                    </Button>
                    |
                    <Button
                      size="medium"
                      color="error"
                      onClick={handleImageRemove}
                      disabled={!image_url}
                    >
                      Remove
                    </Button>
                  </div>
                </Box>
              )}
            </Box>
          </div>

          <div className="col-md-9">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="firstName" className="form-label">
                  First Name
                </label>
                <TextField
                  className="form-control"
                  name="firstname"
                  placeholder="First name"
                  value={userDetails.firstname}
                  onChange={handleInputChange}
                  onBlur={handleBlur} // ✅ Log value when user clicks outside
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="LastName" className="form-label">
                  Last Name
                </label>
                <TextField
                  className="form-control"
                  name="lastname"
                  placeholder="Last name"
                  value={userDetails.lastname}
                  onChange={handleInputChange}
                  onBlur={handleBlur} // ✅ Log value when user clicks outside
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="PersonalPhone" className="form-label">
                  Personal Phone
                </label>
                <TextField
                  className="form-control"
                  name="phone_number"
                  type="number"
                  placeholder="Phone number"
                  value={userDetails.phone_number || ""}
                  onChange={handleInputChange}
                  onBlur={handleBlur} // ✅ Log value when user clicks outside
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="Email" className="form-label">
                  Email
                </label>
                <TextField className="form-control" disabled value={email} />
              </div>
          

              <div className="col-md-6 mt-3">
      <label htmlFor="Email" className="form-label">
        Recover
      </label>

      <div style={{ display: "flex", alignItems: "center",  }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            margin: "5px",
            cursor: "pointer",
          }}
        >
          <span style={{ fontSize: "0.9rem", marginRight: "8px", gap: "15px" }}>
        <button
               type="button"
               onClick={handleOpen}
               className="btn"
               style={{
               backgroundColor: "#b2dfdb", 
               color: "#000",
               border: "none",
               padding: "6px 12px",
               borderRadius: "4px",
               display: "flex",
               alignItems: "center",
               gap: "6px",
               // cursor: isActive ? "pointer" : "not-allowed",
               // opacity: isActive ? 1 : 0.6,
               }}
               // disabled={!isActive || loading} 
             >
                <IoMdDownload />
                 <span>{ "Get Recovery Codes"}</span>
               </button>
          </span>
        </label>
      </div>

      
            <Modal open={open} onClose={handleClose}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "var(--cell-bg-color, #fff)",
                  color: "var(--text-color, #000)",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: "8px",
                  textAlign: "center",
                  minWidth: 350,
                  outline: "none", // prevents focus ring
                }}
              >
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: "var(--text-color, black)",
                  }}
                >
                  <CloseIcon />
                </IconButton>
            
                {loading ? (
                  <Loader />
                ) : recoverdata && recoverdata.two_fa_recovery_codes?.length > 0 ? (
                  <>
                    <Typography variant="h5" gutterBottom>
                      {recoverdata.name}
                    </Typography>
            
                   <table className="modal-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Used</th>
                </tr>
              </thead>
              <tbody>
                {recoverdata.two_fa_recovery_codes.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.code}</td>
                    <td>{item.used ? "Yes" : "No"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            
            <button
              className="add_btn me-3 cursor-pointer"
              onClick={handleCopyCodes}
            >
              Copy
            </button>
            
                    <button
                      className="add_btn me-3"
                      onClick={() => generateTxt(recoverdata)}
                      
                    >
                      Download Codes
                    </button>
                  </>
                ) : (
                  <Typography variant="body1" sx={{ color: "var(--text-color)" }}>
                    No data found.
                  </Typography>
                )}
              </Box>
            </Modal>


              <Modal open={toggleOpen} onClose={handleToggleClose}>
                <Box
                  sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "var(--cell-bg-color, white)",
                    color: "var(--text-color, black)",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: "8px",
                    textAlign: "center",
                    minWidth: 350,
                  }}
                >
              
                  <h3>Please Enter Current Password</h3>
                  <TextField
                  inputRef={passwordRef}
                    type="password"
                    variant="outlined"
                    placeholder="Enter your password"
                    fullWidth
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError(false); 
                    }}
                     onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleConfirm();
                  }
                }}
                    error={passwordError}
                    helperText={passwordError ? "Password is required" : ""}
                    sx={{ mt: 2, mb: 3 }}
                  />
              
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <button onClick={handleToggleClose} className="cancel_btn">
                  Cancel
                </button>
              
                <button
                  type="button"
                  className="add_btn"
                  disabled={loading}
                  onClick={() => {
                    if (!password) {
                      setPasswordError(true);
                      return;
                    }
                    handleConfirm(); // ✅ Call only on button click
                  }}
                >
                  {loading ? "Submitting..." : "Yes"}
                </button>
              </Box>
                </Box>
              </Modal>
    </div>


        <div className="col-md-6 mt-3">
  <label htmlFor="TwoFA" className="form-label">Two Factor</label>
  <div style={{ marginTop: "0.5rem" }}>
            <button
              type="button"
              className="btn"
              onClick={handleToggle}
              style={{
                backgroundColor:  "#ffcdd2" , // Red for "Disable", Green for "Enable"
                color: "#000",
                padding: "6px 12px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                width: "fit-content",
              }}
            >
               Reset 2FA
            </button>
              </div>
            </div> 
                </div>
              </div>
            </div>
          )}
        </form>
      );
    };

export default PersonalSetting;
